import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
function Variant({data,ps_send,variant_id}) {
    const [selectedVariantId, setSelectedVariantId] = useState("");


    useEffect(() => {
        if (variant_id) {
            setSelectedVariantId(variant_id);
        }
    }, [variant_id]);


    const actualizar = (event) => {
        ps_send(Number(event.target.value));
        setSelectedVariantId(Number(event.target.value));
    };

    return (
        <>
            <div>
                <label htmlFor="variants" className="block text-sm font-semibold text-gray-700 mb-1.5">
                    Variante
                </label>
                <select id="variants"
                        value={selectedVariantId}
                        onChange={(e)=>actualizar(e)}
                        className="prod-variant-select">
                    <option value="" disabled>Selecciona una opción</option>
                    {
                        data.map((variant, index) =>
                            <option key={index}  value={variant.id}>
                                {
                                    variant.values.map((value, idx) =>
                                        `${value.attribute}: ${value.value} `
                                    ).join(" - ")
                                }
                            </option>
                        )
                    }
                </select>
            </div>
        </>
    );
}

const mapStateToProps = state => ({})

export default connect(mapStateToProps, {})(Variant)